import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Product from "./Product";
import data from "../../json/index.json";

const Deals = () => {
  return (
    <div className="deals_categories flex-col-center">
      <div className="deals_categories_main container">
        <h1 className="dc-script text-center">Hurry up! Hot deal this week</h1>
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: true }}
          loop={true}
          spaceBetween={50}
          slidesPerView={1}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
        >
          {data.products.map((slide) => (
            <SwiperSlide
              key={slide.name}
              className={`deals_slide${slide.id} deals_slide flex-col-center`}
            >
              <Product item={slide} isBorder={false} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Deals;
